import { render, staticRenderFns } from "./monitoring-rooms.vue?vue&type=template&id=2576931e&"
import script from "./monitoring-rooms.vue?vue&type=script&lang=js&"
export * from "./monitoring-rooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports